import type { SWRConfiguration } from "swr"

export const swrConfig: SWRConfiguration = {
  // Revalidate on focus for fresh data
  revalidateOnFocus: true,
  // Revalidate on reconnect
  revalidateOnReconnect: true,
  // Dedupe requests within 2 seconds
  dedupingInterval: 2000,
  // Focus throttle: don't revalidate more than once per 5s
  focusThrottleInterval: 5000,
  // Keep data fresh, but don't spam
  refreshInterval: 0,
  // Retry on error
  errorRetryCount: 3,
  errorRetryInterval: 5000,
  // Load from cache immediately, revalidate in background
  revalidateIfStale: true,
  shouldRetryOnError: true,
}
